import getLegacyStatus from './getLegacyStatus';

const groupStatusTotals = (data) => {
  if (!data?.allSelfAssessments?.length) return {};

  return data?.allSelfAssessments?.reduce((a, selfAssessment) => {
    const status = getLegacyStatus(selfAssessment);

    return {
      ...a,
      [status]: (a[status] || 0) + 1,
    };
  }, {});
};

export default groupStatusTotals;
